import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = ({ component: Component, roles, ...rest }) => (
    <Route {...rest} render={props => {
        let currentUser = JSON.parse(localStorage.getItem('userAutopartes'));   
        if (!currentUser) {
            return <Redirect to={{ pathname: '/home', state: { from: props.location } }} />
        }        
            return <Component {...props} />           
    }} />
)